module.exports = __webpack_public_path__ + "static/logos5-1914701c6c3ca1831fd29586641629c0.png";